module.exports = __webpack_public_path__ + "static/media/mum.fd61e690.png";